<script lang="ts">
	import { onMount } from "svelte";

	// GDPR consent implementation
	// https://developers.facebook.com/docs/meta-pixel/implementation/gdpr/
	let { track = false } = $props();
	// State is only one way - once loaded it should stay loaded for client session
	let addFbScript = $state(false);
	let onMountInitialization = $state(false);

	// Initialize fbq command queue on mount (client-side only)
	// This allows queueing commands before the actual script loads
	onMount(() => {
		(function (windowObj: Window) {
			if (windowObj.fbq) return;
			const fbqNamespace: FacebookPixel = function (...args: unknown[]) {
				if (fbqNamespace.callMethod) fbqNamespace.callMethod.apply(fbqNamespace, args);
				else fbqNamespace.queue?.push(args);
			};
			windowObj.fbq = fbqNamespace;
			if (!windowObj._fbq) windowObj._fbq = fbqNamespace;
			fbqNamespace.push = fbqNamespace;
			fbqNamespace.loaded = true;
			fbqNamespace.version = "2.0";
			fbqNamespace.queue = [];
		})(window);

		// Start with consent revoked, init pixel, track page view
		if (window.fbq) {
			window.fbq("consent", "revoke");
			window.fbq("init", "223445949151567");
			window.fbq("track", "PageView");
		}

		onMountInitialization = true;
	});

	// React to consent changes and load script when consent granted
	// addFbScript is a one-way latch - once true, stays true
	$effect(() => {
		if (!onMountInitialization || !window.fbq) return;
		if (track && !addFbScript) {
			addFbScript = true;
			window.fbq("consent", "grant");
		} else if (!track && addFbScript) {
			window.fbq("consent", "revoke");
		}
	});
</script>

<svelte:head>
	{#if addFbScript}
		<script async src="https://connect.facebook.net/en_US/fbevents.js"></script>
	{/if}
</svelte:head>
